import {formDataRequest, postRequest} from '../libs/AxiosService.util';

export async function serviceGetSalaryReports(params) {
    return await postRequest('employees/payslip', params);
}
export async function serviceGenrateSalaryPayslips(params) {
    return await postRequest('employees/generate/payslip', params);
}
export async function serviceFetchLastFetchedpaySlip(params) {
    return await postRequest('employees/last/payslip', params);
}
export async function serviceFetchEmployeePaySlips(params) {
    return await postRequest('employees/payslips/per/employee', params);
}
export async function serviceEmployeePaySlipPdfGeneration(params) {
    return await postRequest('employees/payslips/pdf', params);
}
export async function serviceIsSalaryReportGenerated(params) {
    return await postRequest('employees/payslips/check', params);
}

